/**
 * Autore: Salvo de Luca
 * Azienda: Dialogicom s.r.l.s.
 * File: src/lib/config.ts
 * Release: 2.5.0 - Aggiunta configurazione Google Maps per sezione indirizzo
 * Descrizione: Configurazioni globali dell'applicazione
 */

export const APP_CONFIG = {
  APP_NAME: 'Coronatek',
  VERSION: '2.5.0',
  COMPANY: 'Dialogicom s.r.l.s.',
  SUPPORT_EMAIL: 'support@dialogicom.it'
};

export const GOOGLE_MAPS_CONFIG = {
  API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
  DISABLED: import.meta.env.VITE_GOOGLE_MAPS_DISABLED === 'true',
  DEFAULT_ADDRESS: import.meta.env.VITE_GOOGLE_MAPS_DEFAULT_ADDRESS || 'Via Salvatore Averna, 3, 95045 Misterbianco, CT, Italia',
  DEFAULT_LAT: parseFloat(import.meta.env.VITE_GOOGLE_MAPS_DEFAULT_LAT || '37.5189'),
  DEFAULT_LNG: parseFloat(import.meta.env.VITE_GOOGLE_MAPS_DEFAULT_LNG || '15.0094')
};

export const EMAIL_CONFIG = {
  FROM_NAME: 'Coronatek',
  FROM_EMAIL: 'noreply@coronatek.it',
  SUPPORT_EMAIL: 'support@coronatek.it'
};

export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || '',
  TIMEOUT: 30000
};

// Configurazioni form
export const FORM_CONFIG = {
  AUTO_SAVE_DELAY: 2000, // 2 secondi
  VALIDATION_DEBOUNCE: 300, // 300ms
  DEFAULT_COUNTRY: 'IT',
  PHONE_REGIONS: ['europe', 'africa', 'asia', 'americas', 'oceania'] as const,
  DATE_FORMAT: 'DD/MM/YYYY',
  CURRENCY: 'EUR'
} as const;

// Configurazioni theme
export const THEME_CONFIG = {
  DEFAULT_THEME: 'dark',
  AVAILABLE_THEMES: ['light', 'dark'] as const,
  COLORS: {
    primary: 'teal',
    secondary: 'slate',
    accent: 'emerald',
    danger: 'red',
    warning: 'yellow',
    success: 'green'
  }
} as const;

// Export di convenienza
export const { API_KEY: GOOGLE_MAPS_API_KEY, DEFAULT_ADDRESS: DEFAULT_MAPS_ADDRESS } = GOOGLE_MAPS_CONFIG;
export default {
  GOOGLE_MAPS: GOOGLE_MAPS_CONFIG,
  APP: APP_CONFIG,
  FORM: FORM_CONFIG,
  THEME: THEME_CONFIG
}; 